<template>
  <RouterView />
</template>

<script setup lang="ts">
import { useHead } from "@unhead/vue"
const { pageTitle } = usePageTitle()

useHead({
  title: pageTitle,
  titleTemplate: (title: string | undefined) =>
    title
      ? `Takepayments+ Web Portal | ${title}`
      : `Takepayments+ Web Portal`,
})
</script>

<style lang="scss">
@import "~brandcss";

input[type="number"] {
  appearance: textfield;
  margin: 0;
}

input[type="number"]::-webkit-inner-spin-button {
  appearance: none;
}
</style>
